export default "__VITE_ASSET__14e34c48__"